import {FC} from 'react'
import {downloadTemplateContract, uploadMasiveContract} from '../../../../services'
import {ShowSnackBar} from '../../../../../../util/functions'
import {FormMasive} from '../../../../../../components/UI/Form/MasiveV2'

const MasiveUploadContractor: FC = () => {
  const handleUpload = async (formData: FormData) => {
    try {
      const response = await uploadMasiveContract(formData) // Use the service to upload the file
      return response
    } catch (error) {
      ShowSnackBar('Hubo un error', 'error')
    }
  }
  return (
    <FormMasive
      serviceTemplate={downloadTemplateContract}
      handleSendService={handleUpload}
      textData1='Carga masiva de CECOs:'
      textData='Carga masiva de recepcionador de servicio:'
      title='Recepcionador-Servicio'
    />
  )
}

export {MasiveUploadContractor}
